module.exports = __webpack_public_path__ + "static/media/royplus-middle.483d755d.jpg";